export default {
    // The install method will be called with the Vue constructor as
    // the first argument, along with possible options
    install(Vue) {
        Vue.clearTabLocal = function (vm) {
            vm.$store.dispatch('reset');
        }
        Vue.alertDanger = function (msg, vm) {
            vm.$bvModal.msgBoxOk(msg, {
                title: 'Ops! Não deu certo',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
            })
                .then(function () {
                    return;
                })
                .catch(err => {
                    console.log(err);
                });
        }
        Vue.alertSuccess = function (msg, vm) {


            vm.$bvModal.msgBoxOk(msg, {
                title: 'Tudo certo !',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
            })
                .then(function () {
                    return;
                })
                .catch(err => {
                    console.log(err);
                });
        }
        Vue.alertWarning = function (msg, vm) {
            vm.$bvModal.msgBoxOk(msg, {
                title: 'Atenção!',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'warning',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
            })
                .then(function () {
                    return;
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })
        }
        Vue.confirm = function (color, title, text, acceptText, cancelText, accept, cancel, vm) {

            if (!color) {
                color = "warning";
            }

            if (!acceptText) {
                acceptText = "Confirmar";
            }

            if (!cancelText) {
                cancelText = "Desistir";
            }

            if (!title) {
                title = "Como devo prosseguir ?";
            }

            cancel = cancel === "" ? null : cancel;

            vm.$bvModal.msgBoxConfirm(text, {
                title: title,
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: acceptText,
                cancelTitle: cancelText,
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        var ok = accept;
                        ok();
                    }
                    else {
                        var no = cancel;
                        no();
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        }

        Vue.Loading = function (text, tipo, vm) {

            if (text == "")
                text = "Aguarde...";

            if (tipo == "")
                tipo = "radius";

            vm.$vs.loading({ text: text, type: tipo });
        }

        Vue.CloseLoading = function (vm) {
            vm.$vs.loading.close();
        }

        Vue.replaceAll = function (str, needle, replacement) {
            return str.split(needle).join(replacement);
        }
        Vue.soNumeros = function (numsStr) {
            numsStr = numsStr.replace(/[^0-9]/g, '');
            return numsStr;
        }
        Vue.padr = function (n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : n + new Array(width - n.length + 1).join(z);
        }
        Vue.padl = function (n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        Vue.getData = function () {

            // Obtém a data/hora atual
            var data = new Date();

            // Guarda cada pedaço em uma variável
            var dia = data.getDate();           // 1-31
            //var dia_sem = data.getDay();            // 0-6 (zero=domingo)
            var mes = data.getMonth();          // 0-11 (zero=janeiro)
            //var ano2 = data.getYear();           // 2 dígitos
            var ano4 = data.getFullYear();       // 4 dígitos
            //var hora = data.getHours();          // 0-23
            //var min = data.getMinutes();        // 0-59
            //var seg = data.getSeconds();        // 0-59
            //var mseg = data.getMilliseconds();   // 0-999
            //var tz = data.getTimezoneOffset(); // em minutos

            // Formata a data e a hora (note o mês + 1)
            var str_data = Vue.padl(dia, 2, '0') + '/' + (Vue.padl(mes + 1, 2, '0')) + '/' + ano4;
            //var str_hora = hora + ':' + min + ':' + seg;

            return str_data;

        }
        Vue.getDataInput = function () {

            // Obtém a data/hora atual
            var data = new Date();

            // Guarda cada pedaço em uma variável
            var dia = data.getDate();           // 1-31
            //var dia_sem = data.getDay();            // 0-6 (zero=domingo)
            var mes = data.getMonth();          // 0-11 (zero=janeiro)
            //var ano2 = data.getYear();           // 2 dígitos
            var ano4 = data.getFullYear();       // 4 dígitos
            //var hora = data.getHours();          // 0-23
            //var min = data.getMinutes();        // 0-59
            //var seg = data.getSeconds();        // 0-59
            //var mseg = data.getMilliseconds();   // 0-999
            //var tz = data.getTimezoneOffset(); // em minutos

            // Formata a data e a hora (note o mês + 1)
            var str_data = ano4 + '-' + (Vue.padl(mes + 1, 2, '0')) + '-' + Vue.padl(dia, 2, '0');
            //var str_hora = hora + ':' + min + ':' + seg;

            return str_data;

        }
        Vue.convertData = function (data) {
            var strData = data;
            var partesData = strData.split("/");
            var datac = new Date(partesData[2], partesData[1] - 1, partesData[0]);
            return datac;
        }
        Vue.getHora = function () {
            // Obtém a data/hora atual
            var data = new Date();

            // Guarda cada pedaço em uma variável
            var hora = data.getHours();          // 0-23
            var min = data.getMinutes();        // 0-59
            //var seg = data.getSeconds();        // 0-59

            // Formata a data e a hora (note o mês + 1)
            var str_hora = hora + ':' + min;

            return str_hora;

        }
        Vue.fData = function (data) {
            return data.substr(0, 10).split('-').reverse().join('/');
        }
        Vue.fData2 = function (data) {

            if (data == '' || data == null) return null;

            var partesData = data.split('/');
            var datac = partesData[2] + '-' + partesData[1] + '-' + partesData[0];
            return datac;
        }
        Vue.substraiData = function (data1, data2) {

            var day1 = new Date(data1);
            var day2 = new Date(data2);
            var difference = Math.abs(day2 - day1);
            var days = difference / (1000 * 3600 * 24)

            return days;
        }
        Vue.InverteDataNFe = function (data) {
            // 0123456789
            // 2020-11-16T00:00:00
            var datai = data;
            if (data.length >= 10) {
                datai = datai.substr(0, 10);
                datai = datai.substr(8, 2) + "/" + datai.substr(5, 2) + "/" + datai.substr(0, 4);
            }

            return datai;
        }
        Vue.getCorDinamica = function () {
            //var color = Chart.helpers.color;
            //return color(getRandomColor()).alpha(alpha).rgbString();


            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;

        }
        Vue.impRel = function (titulo, base64) {
            if (base64 == '') {
                Vue.alertWarning("Nenhum relatório disponível para exibição", this);
                return;
            }

            var novaJanela = window.open("", "PDF", 'dependent=no,locationbar=no,scrollbars=no,menubar=no,resizable, left=' + (window.innerWidth - 850) / 2 + ', top=' + (window.innerHeight - 800) / 2 + ',width=' + window.innerWidth + ',height=' + window.innerHeight);
            novaJanela.document.write('<html><head><title> ' + titulo + ' </title></head><body><object width=100% height=100% type="application/pdf" data="data:application/pdf;base64,' + base64 + '"><embed type="application/pdf" src="data:application/pdf;base64,' + base64 + '"></embed></object></body></html>');
            novaJanela.window.focus();
        }
        Vue.lookProcessando = (rThis, rOp) => {
            if (rOp == null)
                return false;

            var wRetorno = false;
            for (var i = 0; i < rOp.length; i++) {
                if (rOp[i].hasAttribute('id') && rOp[i].id == 'lookLoading') {
                    wRetorno = true;
                    break;
                }
            }

            if (wRetorno) {
                Vue.notificacao(
                    null,
                    "Aguarde",
                    "Aguarde mais um pouco...",
                    null,
                    rThis
                );
                return true;
            }

            return wRetorno;

        }
        Vue.Pergunta = function (vm, title, content, callSim, callNao) {

            vm.$dialog({
                title: title,
                content: content,
                btns: [{
                    label: 'Confirmar',
                    color: '#66BB6A',
                    ghost: true,
                    callback: () => {
                        if (callSim == null) return;
                        var sim = callSim;
                        sim();

                    },
                },
                {
                    label: 'Cancelar',
                    color: '#E53935',
                    ghost: true,
                    callback: () => {
                        if (callNao == null) return;

                        var nao = callNao;
                        nao();

                    },
                }],
            })
        }

        Vue.Mensagem = function (vm, title, content) {

            vm.$dialog({
                title: title,
                content: content,
                btns: [{
                    label: 'OK',
                    color: '#66BB6A',
                    ghost: true
                }]
            })
        }

        Vue.atob = function (msg) {

            try {

                if (window.btoa(window.atob(msg)) == msg) {
                    return window.atob(msg);
                } else {
                    return msg;
                }
                /*
                    if (msg != "" && msg != null) {
                       //return Base64.atob(msg);
                    }
                */
            } catch (e) {
                return msg;
            }

            //return "";
        }

        Vue.btoa = function (msg) {

            try {
                if (msg != "" && msg != null) {
                    return window.btoa(msg);

                    /* msg = Vue.replaceAll(msg, '⦁', '');
                    msg = Vue.replaceAll(msg, "´", '');
                    msg = Vue.replaceAll(msg, "", '');

                    var wobs = window.btoa(msg.replace(/[\u00A0-\u2666]/g, function (c) {
                        return '&#' + c.charCodeAt(0) + ';';
                    }));

                    return wobs */
                    //return window.btoa(unescape(encodeURIComponent(msg)))


                }
            } catch (e) {

                return msg;
            }

            return "";
        }

        Vue.formatMoney = function (t, e, r, n) {
            var i;
            var o;
            var s;

            isNaN(e = Math.abs(e)) ? 2 : e,
                r = void 0 == r ? "." : r,
                n = void 0 == n ? "," : n,
                i = t < 0 ? "-" : "",
                o = String(parseInt(t = Math.abs(Number(t) || 0).toFixed(e))), s = (s = o.length) > 3 ? s % 3 : 0;


            return i + (s ? o.substr(0, s) + n : "") + o.substr(s).replace(/(\d{3})(?=\d)/g, "$1" + n) + (e ? r + Math.abs(t - o).toFixed(e).slice(2) : "");

        }

        Vue.MascaraMonetaria = function (val) {

            var valor = val;
            var valorFormatado = valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            return valorFormatado;

        }

        Vue.trataNULL = function (valor, padrao, prefix) {
            if (valor == null || valor == "") return padrao;
            return prefix + valor;
        }
    }
}



